module.exports = __webpack_public_path__ + "static/media/clothes.85e393bd.svg";